import React from 'react';
import logoUrl from '../assets/safer Savvy.svg';

interface LogoProps {
  size?: number;
  className?: string;
}

const SaferSavvyLogo: React.FC<LogoProps> = ({ size = 80, className = '' }) => (
  <img
    src={logoUrl}
    alt="SaferSavvy"
    height={size}
    draggable={false}
    style={{ height: size, width: 'auto' }}
    className={`object-contain select-none${className ? ` ${className}` : ''}`}
  />
);

export default SaferSavvyLogo;
